import * as i0 from "@angular/core";
export let TruncatePipe = /*#__PURE__*/(() => {
  class TruncatePipe {
    transform(value, limit) {
      if (!value || typeof value !== "string") return value;
      return value.length > limit ? value.substring(0, limit) + '...' : value;
    }
    static {
      this.ɵfac = function TruncatePipe_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || TruncatePipe)();
      };
    }
    static {
      this.ɵpipe = /*@__PURE__*/i0.ɵɵdefinePipe({
        name: "truncate",
        type: TruncatePipe,
        pure: true
      });
    }
  }
  return TruncatePipe;
})();